<template>
  <div class="bb-contact-form-mailing">
    <div
      class="bb-contact-form-mailing-header"
      :class="[!isShowButton && 'bb-contact-form-mailing-header_small']"
    >
      <div class="bb-contact-form-mailing-header__title">
        {{ title }}
        <HelpPopup
          v-if="textHelperPopup"
          :text="textHelperPopup"
          :addClassPopup="addClassPopup"
        />
      </div>
      <div
        v-if="isShowButton"
        class="bb-sign-in-button-google"
        @click="handleClick"
      >
        <div v-html="GoogleIcon()"/>
        Add new sender's address
      </div>
    </div>
    <div
      v-if="mailingList.length"
      class="bb-contact-form-mailing-body"
    >
      <ContactFormMailingItem
        v-for="item in mailingList"
        :key="item._id"
        :item="item"
        @onDisconnect="onDisconnect"
      />
    </div>
    <ContactFormMailingSelect
      v-if="isShowSelect"
      :company="company"
    />
  </div>
</template>

<script>
import { GoogleIcon } from '@/constants/icon'
import GmailApi from '@/api/Gmail/api'
import {DOMAINS} from '@/constants/domainListPlatform'
import { CONTACT_FORM_MAILING, CONTACT_FORM_HR, CONTACT_FORM_CLIENT, CONTACT_FORM_PROJECT, CONTACT_FORM_ACADEMY }
  from '@/constants/contactFormServices'
// eslint-disable-next-line max-len
import ContactFormMailingItem from '@/components/Settings/Companies/CompanyForm/ContactFormMailing/ContactFormMailingItem'
// eslint-disable-next-line max-len
import ContactFormMailingSelect from '@/components/Settings/Companies/CompanyForm/ContactFormMailing/ContactFormMailingSelect'
import HelpPopup from "../HelpPopup/HelpPopup.vue";

export default {
  name: 'ContactFormMailing',
  components: {ContactFormMailingSelect, ContactFormMailingItem, HelpPopup},
  props: {
    company: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: String,
      default: ''
    },
    textHelperPopup: {
      type: String,
      default: ''
    },
    addClassPopup: {
      type: String,
      default: '',
    },
    type: {
      type: Number,
      default: CONTACT_FORM_MAILING
    }
  },
  data: () => ({
    GoogleIcon,
    currentDomain: '',
    mailingList: []
  }),
  computed: {
    isShowButton () {
      return this.type === CONTACT_FORM_MAILING || !this.mailingList.length
    },
    isShowSelect () {
      return this.type === CONTACT_FORM_CLIENT
    },
    gmailAuth () {
      switch (this.type) {
      case CONTACT_FORM_HR:
        return 'gmailHrAuth';
      case CONTACT_FORM_PROJECT:
        return 'gmailProjectAuth';
      case CONTACT_FORM_CLIENT:
        return 'gmailClientAuth';
        case CONTACT_FORM_ACADEMY:
          return 'gmailAcademyAuth';
      default:
        return 'gmailMailingAuth';
      }
    },
    getGmailList () {
      switch (this.type) {
      case CONTACT_FORM_HR:
        return 'gmailHr'
      case CONTACT_FORM_CLIENT:
        return 'gmailClient'
      case CONTACT_FORM_PROJECT:
        return 'gmailProject'
      case CONTACT_FORM_ACADEMY:
        return 'gmailAcademy'
      default:
        return 'gmailMailing'
      }
    },
    gmailLogout () {
      switch (this.type) {
      case CONTACT_FORM_HR:
        return 'gmailHrLogout'
      case CONTACT_FORM_PROJECT:
        return 'gmailProjectLogout'
      case CONTACT_FORM_CLIENT:
        return 'gmailClientLogout'
      case CONTACT_FORM_ACADEMY:
        return 'gmailAcademyLogout'
      default:
        return 'gmailMailingLogout'
      }
    }
  },
  methods: {
    closeWindow () {
      const { location = {} } = window
      const { hash } = location
      if (hash === '#authGoogle') {
        window.opener.addToWindow()
        window.close()
      }
    },
    checkDomainPlatform () {
      const { location = {} } = window
      const { href } = location
      const currentItem = DOMAINS.find((el) => {
        const { name } = el
        return href.includes(name)
      })
      this.currentDomain = currentItem
    },
    createStyleWindow (data) {
      const { innerHeight, innerWidth } = window
      const left = (innerWidth / 2) - (470 / 2)
      const height = innerHeight < 860 ? 500 : innerHeight * 0.6
      const top = (innerHeight / 2) - (height / 2)
      const style = `width=470, height=${height}, top=${top}, left=${left},status=no,toolbar=no,menubar=no`
      window.open(
        data,
        'displayWindow',
        style
      )
    },
    addToWindow () {
      this.gmailMailing()
    },
    async handleClick () {
      const { id } = this.currentDomain
      window.addToWindow = this.addToWindow
      try {
        const { data } = await GmailApi[this.gmailAuth]({domain: id})
        this.createStyleWindow(data)
      } catch (err) {
        console.error(err)
      }
    },
    async gmailMailing () {
      const { id } = this.company
      try {
        const { data } = await GmailApi[this.getGmailList](id)
        this.mailingList = data
      } catch (err) {
        console.error(err)
      }
    },
    async onDisconnect (item) {
      const { _id } = item
      const { id } = this.company
      try {
        await GmailApi[this.gmailLogout]({ _id, company: id })
        const index = this.mailingList.findIndex((el) => el._id === _id)
        this.mailingList.splice(index, 1)
      } catch (err) {
        console.error(err)
      }
    }
  },
  beforeMount () {
    this.closeWindow()
    this.gmailMailing()
    this.checkDomainPlatform()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../sass/variables";
@import "../../../../../sass/mixins";

  .bb-contact-form-mailing {
    padding: 10px;
    border: 1px dashed $color-mercury;
    border-radius: 5px;

    & + & {
      margin: 9px 0 0 0;
    }
  }

  .bb-contact-form-mailing-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__title {
      font-size: 13px;
      font-weight: 600;
      line-height: 18px;
      color: $color-denim;
    }

    &_small {
      margin: 10px 0 -10px 0;
    }
  }

  .bb-sign-in-button-google {
    display: flex;
    align-items: center;
    justify-content: center;
    grid-gap: 0 10px;
    @include global-font;
    font-size: 12px;
    line-height: 14px;
    color: $color-black;
    width: 189px;
    padding: 6px 0;
    border: 1px solid $color-link-water;
    border-radius: 4px;
    cursor: pointer;

    &_one {
      pointer-events: none;
      color: $color-silver-deep;
    }
  }

  .bb-contact-form-mailing-body {
    margin: 19px 0 0 0;
  }

</style>

<style lang="scss">
@import "../../../../../sass/variables";

  .bb-sign-in-button-google {

    svg {
      width: 20px;
      height: 20px;
    }

    &_one {
      svg path {
        fill: $color-silver-deep;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Settings/Companies/CompanyForm/ContactFormMailing/ContactFormMailing.vue